import React, { useState } from "react";
import { useForm } from 'react-hook-form'
import Alert from '../alerts'
import { Link } from "react-router-dom";
import {  FiEye , FiEyeOff } from "react-icons/fi";

const FormValidation = ({ items, onSubmit, alerts, onChange }) => {
  const { handleSubmit, errors, register } = useForm();
  const [emailValidError, setEmailValidError] = useState(false);
  const [isShowPass, setIsShowPass] = useState(false);
  const [errorUserName, setErrorUserName] = useState(false);

  const onSubmitFn = data => {
    if (onSubmit) {
      onSubmit(data)
    }
  }
  items = items.map(item => {
    item['ref'] = register(item['error'])
    return item
  })

  

  const handleEmailChange = (value) => {
    const regex =
      // eslint-disable-next-line no-useless-escape
      /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    if (value === "") {
      setEmailValidError(false);
    } else if (regex.test(value) === false) {
      setEmailValidError(true);
    } else {
      setEmailValidError(false);
    }
  };

  const handleUsernameChange = (value) => {
    if (value.includes(" ")) {
      setErrorUserName(true)
    } else {
      setErrorUserName(false)
    }
  };

  //
  const handleEyePass=()=>{
    setIsShowPass(!isShowPass);
  }

  return (
    <form
      onSubmit={handleSubmit(onSubmitFn)}
      className="form flex flex-wrap w-full">
      {alerts &&
        items.map((item, i) => {
          if (!errors[item.name]) return null
          let msg = errors[item.name].message
          if (msg.length === 0) msg = `${item.label} is required`
          return (
            <div className="flex flex-col w-full">
              {errors[item.name] && (
                <div className="mb-2" key={i}>
                  <Alert
                    color="bg-transparent border-red-500 text-red-500"
                    borderLeft
                    raised>
                    {msg}
                  </Alert>
                </div>
              )}
            </div>
          )
        })}
      <div className="w-full vendor-flex-box">
        {items.map((item, i) => {
          if (item.type === 'checkbox') {
            return (
              <div className="form-element">
                {item.label && <div className="form-label">{item.label}</div>}
                <div className="flex items-center justify-start space-x-2">
                  {item.options.map((option, j) => (
                    <label className="flex items-center justify-start space-x-2">
                      <input
                        ref={item.ref}
                        type="checkbox"
                        value={item.value}
                        id={item.id}
                        name={item.name}
                        className={`form-checkbox h-4 w-4 ${errors[item.name + '11111'] ? 'text-red-500' : ''
                          }`}
                      />
                      <span
                        className={`${errors[item.name] ? 'text-red-500' : ''
                          }`}>
                        {option.label}
                      </span>
                    </label>
                  ))}
                </div>
              </div>
            )
          }
          if (item.type === 'radio') {
            return (
              <div className="form-element">
                {item.label && <div className="form-label">{item.label}</div>}
                <div className="flex items-center justify-start space-x-2">
                  {item.options.map((option, j) => (
                    <label className="flex items-center justify-start space-x-2">
                      <input
                        type="radio"
                        value={item.value}
                        id={item.id}
                        name={item.name}
                        ref={register({ required: true })}
                        className={`form-radio h-4 w-4 ${errors[item.name] ? 'text-red-500' : ''
                          }`}
                      />
                      <span
                        className={`${errors[item.name] ? 'text-red-500' : ''
                          }`}>
                        {option.label}
                      </span>
                    </label>
                  ))}
                </div>
              </div>
            )
          }
          if (item.type === 'select') {
            return (
              <div className="form-element">
                {item.label && <div className="form-label">{item.label}</div>}
                <select
                  ref={item.ref}
                  name={item.name}
                  value={item.value}
                  id={item.id}
                  className={`form-select ${errors[item.name] ? 'border border-red-500' : ''
                    }`}>
                  {item.options.map((option, j) => (
                    <option key={j} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
                {!alerts && errors[item.name] && (
                  <div className="form-error">{errors[item.name].message}</div>
                )}
              </div>
            )
          }
          if (item.type === 'textarea') {
            return (
              <>
                <div className="form-element">
                  {item.label && <div className="form-label">{item.label}</div>}
                  <textarea
                    ref={item.ref}
                    name={item.name}
                    value={item.value}
                    id={item.id}
                    className={`form-textarea ${errors[item.name] ? 'border border-red-500' : ''
                      }`}
                    rows="3"
                    placeholder={item.placeholder}></textarea>
                  {!alerts && errors[item.name] && (
                    <div className="form-error">
                      {errors[item.name].message}
                    </div>
                  )}
                </div>
              </>
            )
          }
          if (item.type==="password") {
            return (
              <>
                <div className="form-element lg:w-1/2">
                  {item.label && <div className="form-label">{item.label}</div>}
                  <input
                    ref={item.ref}
                    id={item.id}
                    value={item.value}
                    name={item.name}
                    type={isShowPass ? "text" : "password"}
                    onChange={(e) => handleEmailChange(e.target.value)}
                    className={`form-input ${errors[item.name] ? 'border-red-500' : ''
                      }`}
                    placeholder={item.placeholder}
                  />
                  {!isShowPass ?
                  < FiEyeOff
                  onClick={() => handleEyePass()}
                  style={{ position: "relative", left: "150px", top: "-25px" }}
                  type="text"
                  />:
                  <FiEye
                  onClick={() => handleEyePass()}
                  style={{ position: "relative", left: "150px", top: "-25px" }}
                  type="password"
                  />
                  }
                  {!alerts && errors[item.name] && (
                    <div className="form-error">{errors[item.name].message}</div>
                  )}
                  {emailValidError && (
                    <div className="form-error">Password is required</div>
                  )}
                </div>
              </>
            )
          }
          if (item.type === 'email' && item.inputType === 'vendor-input') {
            return (
              <>
                <div className="form-element lg:w-1/2">
                  {item.label && <div className="form-label">{item.label}</div>}
                  <input
                    ref={item.ref}
                    id={item.id}
                    value={item.value}
                    name={item.name}
                    type={item.type}
                    onChange={(e) => handleEmailChange(e.target.value)}
                    className={`form-input ${errors[item.name] ? 'border-red-500' : ''
                      }`}
                    placeholder={item.placeholder}
                  />
                  {!alerts && errors[item.name] && (
                    <div className="form-error">{errors[item.name].message}</div>
                  )}
                  {emailValidError && (
                    <div className="form-error">Password is required</div>
                  )}
                </div>
              </>
            )
          }
          if (item.type === 'email' && item.inputType !== 'vendor-input') {
            return (
              <>
                <div className="form-element lg:w-1/2">
                  {item.label && <div className="form-label">{item.label}</div>}
                  <input
                    ref={item.ref}
                    id={item.id}
                    value={item.value}
                    name={item.name}
                    type={item.type}
                    onChange={(e) => handleEmailChange(e.target.value)}
                    className={`form-input ${errors[item.name] ? 'border-red-500' : ''
                      }`}
                    placeholder={item.placeholder}
                  />
                  {!alerts && errors[item.name] && (
                    <div className="form-error">{errors[item.name].message}</div>
                  )}
                  {emailValidError && (
                    <div className="form-error">Please enter valid email</div>
                  )}
                </div>
              </>
            )
          }
          if (item.type === 'date') {
            return (
              <>
                <div className="form-element lg:w-1/2">
                  {item.label && <div className="form-label">{item.label}</div>}
                  <input
                    ref={item.ref}
                    id={item.id}
                    value={item.value}
                    name={item.name}
                    type={item.type}
                    min={item.min}
                    onChange={(e) => onChange(e.target.value, item.id)}
                    className={`form-input ${errors[item.name] ? 'border-red-500' : ''
                      }`}
                    placeholder={item.placeholder}
                  />
                  {!alerts && errors[item.name] && (
                    <div className="form-error">{errors[item.name].message}</div>
                  )}
                  {emailValidError && (
                    <div className="form-error">Please enter valid email</div>
                  )}
                </div>
              </>
            )
          }
          if (item.inputType === 'user-input') {
            return (
              <>
                <div className="form-element lg:w-1/2">
                  {item.label && <div className="form-label">{item.label}</div>}
                  <input
                    ref={item.ref}
                    id={item.id}
                    value={item.value}
                    name={item.name}
                    type={item.type}
                    onChange={(e) => onChange(e.target.value, item.id)}
                    className={`form-input ${errors[item.name] ? 'border-red-500' : ''
                      }`}
                    placeholder={item.placeholder}
                  />
                  {!alerts && errors[item.name] && (
                    <div className="form-error">{errors[item.name].message}</div>
                  )}
                  {emailValidError && (
                    <div className="form-error">Please enter valid email</div>
                  )}
                </div>
              </>
            )
          }
          if (item.inputType === 'vendor-input') {
            return (
              <>
                <div className="form-element lg:w-1/2">
                  {item.label && <div className="form-label">{item.label}</div>}
                  <input
                    ref={item.ref}
                    id={item.id}
                    value={item.value}
                    name={item.name}
                    type={item.type}
                    onChange={(e) => onChange(e.target.value, item.id)}
                    className={`form-input ${errors[item.name] ? 'border-red-500' : ''
                      }`}
                    placeholder={item.placeholder}
                  />
                  {!alerts && errors[item.name] && (
                    <div className="form-error">{errors[item.name].message}</div>
                  )}
                  {emailValidError && (
                    <div className="form-error">Please enter valid email</div>
                  )}
                </div>
              </>
            )
          }
          if (item.type === 'email' && item.inputType === 'vendor-input') {
            return (
              <>
                <div className="form-element">
                  {item.label && <div className="form-label">{item.label}</div>}
                  <input
                    ref={item.ref}
                    id={item.id}
                    value={item.value}
                    name={item.name}
                    type={item.type}
                    onChange={(e) => handleEmailChange(e.target.value)}
                    className={`form-input ${errors[item.name] ? 'border-red-500' : ''
                      }`}
                    placeholder={item.placeholder}
                  />
                  {!alerts && errors[item.name] && (
                    <div className="form-error">{errors[item.name].message}</div>
                  )}
                  {emailValidError && (
                    <div className="form-error">Please enter valid email</div>
                  )}
                </div>
              </>
            )
          }
          if (item.inputType === 'username') {
            return (
              <>
                <div className="form-element lg:w-1/2">
                  {item.label && <div className="form-label">{item.label}</div>}
                  <input
                    ref={item.ref}
                    id={item.id}
                    value={item.value}
                    name={item.name}
                    type={item.type}
                    onChange={(e) => handleUsernameChange(e.target.value)}
                    className={`form-input ${errors[item.name] ? 'border-red-500' : ''
                      }`}
                    placeholder={item.placeholder}
                  />
                  {!alerts && errors[item.name] && (
                    <div className="form-error">{errors[item.name].message}</div>
                  )}
                  {errorUserName && (
                    <div className="form-error">Username should not have spaces</div>
                  )}
                </div>
              </>
            )
          }
          if(item.inputType === 'hidden') {
            return <div className="form-element hide"></div>
          }
          return (
            <>
              <div className="form-element">
                {item.label && <div className="form-label">{item.label}</div>}
                <input
                  ref={item.ref}
                  name={item.name}
                  type={item.type}
                  value={item.value}
                  id={item.id}
                  className={`form-input ${errors[item.name] ? 'border-red-500' : ''
                    }`}
                  placeholder={item.placeholder}
                />
                {!alerts && errors[item.name] && (
                  <div className="form-error">{errors[item.name].message}</div>
                )}
              </div>
            </>
          )
        })}
      </div>
      <div>
      <button
        type="submit"
        className="btn btn-default bg-blue-500 hover:bg-blue-600 text-white btn-rounded"
      >Submit</button>
            <Link to="/login" className="link ml-5">
              Go back to login
            </Link>
            </div>
    </form>
  )
}
export default FormValidation
